// For an aspect ratio of 5:2
export const imageWidth = '100%';
export const imagePaddingTop = '40%';

export const imageBackgroundColor = 'rgba(231, 231, 231, 0.6)' // theme.palette.secondary['50'] at opacity 60%